import { combineReducers } from 'redux';
import { FNI_VERIFICATION } from './actionTypes';
import util from '../util';

export default combineReducers({
  fni: util.requestReducer(FNI_VERIFICATION),
});
